import store from "../../../redux/store";
import { handleError } from "../../../utils/handleError";

const addWorkspaceIdToUrl = () => {
  try {
    const url = new URL(window.location.href);
    const workspaceId = store.getState().fpAppV4Data.workspaceId;
    if (!url.href.includes(workspaceId)) {
      const newUrl = url.origin + `/chat/${workspaceId ? workspaceId : ""}`;
      window.history.pushState({}, "", newUrl);
    }
  } catch (error) {
    handleError({ error, location: "addWorkspaceIdToUrl" });
  }
};

export default addWorkspaceIdToUrl;
